import { isNumber } from 'lodash-es';

import { SparklineYAxisProps } from '../types/sparkline-y-axis-props.js';

export const getShowContextValues = (
  yAxis: SparklineYAxisProps,
  contextValues: { min: number; max: number },
) => {
  const { min, max } = contextValues;
  let showContextMin = min < 0;
  let showContextMax = max > 0;
  if (isNumber(yAxis.min) && showContextMin) {
    showContextMin = yAxis.min <= min;
  }
  if (isNumber(yAxis.max) && showContextMax) {
    showContextMax = yAxis.max >= max;
  }

  return { showContextMin, showContextMax };
};
